import Main from "@/components/main/main";

export default [
  {
    path: "/",
    name: "_home",
    redirect: "/",
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: "/",
        name: "Home",
        meta: {
          hideInMenu: true,
          title: "首页"
        },
        component: () => import("@/views/goStart")
      }
      // {
      //   path: "/goStart",
      //   name: "GoStart",
      //   component: () => import("@/views/goStart")
      // }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/routers.js